export default __webpack_public_path__ + "static/media/FullBrandyLogo.2baf9775.svg";